import React from 'react'
import { MySvgIcon } from './MySvgIcon'

export interface IconEyeShowProps {
  className?: string
  focusable?: boolean
  title?: string
}

export const IconEyeShow: React.FC<IconEyeShowProps> = ({ ...props }) => {
  return (
    <MySvgIcon width="18px" viewBox="0 0 18 18" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g fill="#1E3C70" fillRule="nonzero">
          <g transform="translate(0.000000, 3.000000)">
            <path d="M9,2.49998396 C8.66878979,2.50517683 8.34003094,2.55779508 8.02375,2.65625 C8.1700502,2.91353643 8.2479466,3.20403405 8.25,3.5 C8.25,4.46649831 7.46649831,5.25 6.5,5.25 C6.20403405,5.2479466 5.91353643,5.1700502 5.65625,5.02375 C5.23995453,6.46752004 5.79421447,8.01569435 7.0322398,8.86720309 C8.27026512,9.71871182 9.91426509,9.68249163 11.1135869,8.77728389 C12.3129087,7.87207615 12.7984459,6.30099328 12.3189677,4.87695871 C11.8394895,3.45292413 10.5025822,2.49546573 9,2.49998396 L9,2.49998396 Z M17.89125,5.54375 C16.1965625,2.2371875 12.8415625,0 9,0 C5.1584375,0 1.8025,2.23875 0.10875,5.5440625 C-0.0362272149,5.83084369 -0.0362272149,6.16946881 0.10875,6.45625 C1.8034375,9.7628125 5.1584375,12 9,12 C12.8415625,12 16.1975,9.76125 17.89125,6.4559375 C18.0362272,6.16915631 18.0362272,5.83053119 17.89125,5.54375 Z M9,10.5 C5.9171875,10.5 3.0909375,8.78125 1.5646875,6 C3.0909375,3.21875 5.916875,1.5 9,1.5 C12.083125,1.5 14.9090625,3.21875 16.4353125,6 C14.909375,8.78125 12.083125,10.5 9,10.5 Z"></path>
          </g>
        </g>
      </g>
    </MySvgIcon>
  )
}
